import { IStore } from 'store/configureStore';
import { selectCustomFieldValuesState } from '../../../store/selectors';

export const selectSyncFieldState = (state: IStore) =>
    selectCustomFieldValuesState(state).customFieldValueSyncPrism;

export const selectIsCustomFieldSyncronizing = (state: IStore) =>
    selectSyncFieldState(state).isSyncronizing;
